// React
import React from 'react';

// Components
import { MainCard, AddOccupantsForm } from 'components';

// Packages
import { Grid, Box } from '@mui/material';

const RegistrationOccupants = ({
    setStep,
    setOccupants,
    occupants,
    loading,
    editingIndex,
    setEditingIndex,
    handleAddOrUpdateOccupant
}) => {
    return (
        <Grid
            item
            sm={8}
            sx={{
                backgroundColor: 'rgba(33, 35, 34, 0.05)',
                height: '100vh',
                padding: '40px',
                boxSizing: 'border-box',
                overflowY: 'auto',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <MainCard
                style={{ padding: '10px 30px', fontSize: '1rem', lineHeight: '1.6' }}
            >
                <h2
                    style={{
                        color: '#012D27',
                        fontSize: '1.8rem',
                        fontWeight: '600',
                        marginBottom: '20px',
                        textAlign: 'center'
                    }}
                >
                    {editingIndex !== null
                        ? 'Edit Occupant Information'
                        : 'Occupant Information'}
                </h2>
                <Box>
                    <AddOccupantsForm
                        setStep={setStep}
                        setOccupants={setOccupants}
                        occupants={occupants}
                        loading={loading}
                        editingOccupant={
                            editingIndex !== null ? occupants[editingIndex] : null
                        }
                        setEditingOccupant={setEditingIndex}
                        handleAddOrUpdateOccupant={handleAddOrUpdateOccupant}
                    />
                </Box>
            </MainCard>
        </Grid>
    );
};

export default RegistrationOccupants;
